export const initialAuthState = {
    error: undefined,
    fetching: false,
    session: undefined,
    user: undefined,
}